import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';


export interface AliasChannel {
  codSubscription: string;
  codChannel: string;
  codAlias: string;
};

@Injectable()
export class PortalTemplatesService {
    private portalUrl = 'api/portalTemplates';
    private aliasUrl = 'api/alias';

    constructor(private sxHttp: SxHttpService) { }

    getPortalTeamplatesByNivel(codSistema: string, codNegocio: string = null): Observable<ItemGeneralListado[]> {
      const params = {
        codSistema,
      };

      if (codNegocio !== null) {
        params['codNegocio'] = codNegocio;
      }

      return this.sxHttp.get(this.portalUrl, params)
        .map(response => {
          return response.json().data.map(portal => {
            return {
              id: portal.codPortal,
              Titulo: portal.descripcion,
              Descripcion: portal.descripcionExt,
              Imagen: portal.imagen,
            };
          }) as ItemGeneralListado[];
        });
    }

    GetPagesByCodPortal(codPortal: string): Observable<ItemGeneralListado[]> {
      const url = this.portalUrl + `/${codPortal}/pages`;

      return this.sxHttp.get(url)
        .map(response => {
          return response.json().data.map(page => {
            return {
              id: page.codPage,
              Titulo: page.descripcion,
              Descripcion: page.descripcionExt,
              Imagen: page.imagen,
            };
          }) as ItemGeneralListado[];
        });
    }

    getChannelAlias(codSistema, codNegocio): Promise<any> {
      const url = `${this.aliasUrl}/${codSistema}/${codNegocio}`;

      return this.sxHttp.get(url)
        .toPromise()
        .then(res => res.json().data);
    }

    createChannelAlias(alias: AliasChannel): Promise<any> {
      return this.sxHttp.post(this.aliasUrl, alias)
        .toPromise()
        .then(response => response.json().data);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/portalTemplates.service.ts